import React, { useEffect } from 'react'
import parse from 'html-react-parser'
import SkeletonLoaderAboutUs from '../../../Common/skeleton/SkeletonAboutUs/SkeletonLoaderAboutUs'
import Aos from 'aos'
const host = process.env.REACT_APP_API_SERVER
const AboutUs = ({ loadingHomeAboutNineSecDataApi, HomeAboutNineSecDataApiData, HomeAboutNineSecDataApiError, }) => {

    useEffect(function () {
        Aos.init({ duration: 1000 });
      }, []);
    return (
        <>
       {loadingHomeAboutNineSecDataApi?
       <SkeletonLoaderAboutUs/>
       :
        <section className="about-wrap style1" id="aboutus">
            <div className="container"  data-aos="fade-up">
                <div className="heading">
                    {" "}
                    <div className="content-title style2 mb-15">
                        <span className="ruby">
                        <img src="/website/assets/img/secion-shape-1.png" alt="Image" />{" "}
                            <h2>ABOUT US </h2>
                            <img src="/website/assets/img/secion-shape-2.png" alt="Image" />
                        </span>
                    </div>{" "}
                </div>
                <div className="row gx-5 align-items-center">
                    <div className="col-lg-6">
                        <div className="about-sec-bg">
                            <img
                                className="about-sec-bg"
                                src={`${host}${HomeAboutNineSecDataApiData?.about_us_image}`}
                                alt=""
                            />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="about-content">
                            <div className="content-title style2 mb-15">
                                <h3 className="headin">{HomeAboutNineSecDataApiData?.about_us_title}</h3>
                            </div>
                            <p>
                                {HomeAboutNineSecDataApiData?.about_us_subtitle ? parse(HomeAboutNineSecDataApiData?.about_us_subtitle) : ''}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>}
        </>
    )
}

export default AboutUs